enum AuthEnum {
  TOKEN = '__viacertaNegotiationPortalToken__',
  USER = '__viacertaNegotiationPortalUser__',
}

export default AuthEnum
